import { Fragment } from "react";
import { Link } from "react-router-dom";
import classes from "./storefilter.module.css";
import Flip from "react-reveal/Flip";

const StoreFilter = () => {
  return (
    <Fragment>
      <Flip top>
        <section className={classes.section}>
          <Link to="/trouser">
            Trousers & <br /> Shorts
          </Link>
          <Link to="/shirts">
            Shirts & <br />
            CropTops
          </Link>
          <Link to="/gown">Party Gowns</Link>
          <Link to="/shoes">
            Shoes & <br /> Sandals
          </Link>
        </section>
      </Flip>
    </Fragment>
  );
};

export default StoreFilter;
